const configuredApiUrl = (import.meta.env.VITE_API_URL ?? "").trim();

// In local development we default to relative API paths so Vite proxy handles
// /api/auth, /trpc, and /upload consistently.
const preferRelativeApiInDev =
  import.meta.env.DEV && import.meta.env.VITE_USE_ABSOLUTE_API !== "1";

const fallbackApiUrl = import.meta.env.PROD
  ? "https://api.withquire.com"
  : "http://localhost:8787";

const resolvedAbsoluteApiUrl = configuredApiUrl || fallbackApiUrl;

const resolveDevRedirectApiUrl = () => {
  if (configuredApiUrl) return configuredApiUrl;
  if (typeof window === "undefined") return "http://localhost:8787";
  const protocol = window.location.protocol || "http:";
  const hostname = window.location.hostname || "localhost";
  return `${protocol}//${hostname}:8787`;
};

const redirectApiUrl = import.meta.env.DEV
  ? resolveDevRedirectApiUrl()
  : resolvedAbsoluteApiUrl;

export const runtimeConfig = {
  apiUrl: preferRelativeApiInDev ? "" : resolvedAbsoluteApiUrl,
  portalUrl: import.meta.env.DEV
    ? "http://localhost:8787"
    : "https://portal.withquire.com",
  absoluteApiUrl: resolvedAbsoluteApiUrl,
  redirectApiUrl,
};
